import React, { useEffect } from "react";

export const aiProviders = {
  GEMINI_VIA_REST: ["gemini-1.5-flash", "gemini-1.5-pro"],
  GROQ: ["openai/gpt-oss-120b", "groq/compound"],
};

export type AiProvider = keyof typeof aiProviders;

interface AiConfigSelectorProps {
  aiProvider: AiProvider;
  setAiProvider: (provider: AiProvider) => void;
  modelName: string;
  setModelName: (modelName: string) => void;
}

export function AiConfigSelector({
  aiProvider,
  setAiProvider,
  modelName,
  setModelName,
}: AiConfigSelectorProps) {
  useEffect(() => {
    setModelName(aiProviders[aiProvider][0]);
  }, [aiProvider, setModelName]);

  return (
    <>
      <div className="form-group">
        <label htmlFor="aiProvider">AI Provider</label>
        <select
          id="aiProvider"
          className="form-control"
          value={aiProvider}
          onChange={(e) => setAiProvider(e.target.value as AiProvider)}
        >
          {Object.keys(aiProviders).map((provider) => (
            <option key={provider} value={provider}>
              {provider}
            </option>
          ))}
        </select>
      </div>
      <div className="form-group">
        <label htmlFor="modelName">Model Name</label>
        <select
          id="modelName"
          className="form-control"
          value={modelName}
          onChange={(e) => setModelName(e.target.value)}
        >
          {aiProviders[aiProvider].map((model) => (
            <option key={model} value={model}>
              {model}
            </option>
          ))}
        </select>
      </div>
    </>
  );
}
